import { blueColour, defaultFontNormal } from "../utils/styling";
import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
export const getScopeAndExclusionsParagraphs = (data) => {
  const {
    groupName,
    formattedPoAStart,
    formattedPoAEnd,
    ultimateParentName,
    reportingCompanyName,
  } = data;

  const paragraphs = [
    {
      segments: [
        {
          text: "The purpose of this report is to present the outcome of our work in preparing the CIR calculations for the ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: groupName,
          font: defaultFontNormal,
        },
        {
          text: " group for the period of account ended ",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
        },
        {
          text: ". It sets out a summary of the outcome of the calculations, along with details of the key facts, circumstances and considerations upon which the calculations and the CIR return are based.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "This report should be read in conjunction with a review of the Summary Output spreadsheet, which summarises the CIR calculations undertaken, the inputs to those calculations, and the outcome of the calculations; and the draft CIR return which includes the information specified in the CIR legislation to form a full and complete return. It is important that you fully review these calculations, and the contents of this report, and advise us of any errors or inaccuracies, as these form the basis for the information set out in the CIR return.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Our work included the following: ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "[include/delete as appropriate]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Assisting with the identification of the ultimate parent of the group",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Assisting with determining the period of account of the group",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Appointing a nominated reporting company for the group",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Preparing the CIR calculations for the group, ",
          font: defaultFontNormal,
        },
        {
          text: "[including preparing the calculations applying the group ratio method of calculation]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Completing the CIR return on behalf of the group, based on the outcome of the calculations undertaken",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "For the avoidance of doubt, our scope of work did not include the following: ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "[include/delete as appropriate]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Assisting with the identification of the ultimate parent of the group. You have informed us that ",
          font: defaultFontNormal,
        },
        {
          text: ultimateParentName,
          font: defaultFontNormal,
        },
        {
          text: " is the Ultimate Parent of the group, and we have prepared the calculations on this basis.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Assisting with determining the period of account of the group. You have informed us that the period of account of the group runs from ",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAStart,
          font: defaultFontNormal,
        },
        {
          text: "to",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
        },
        {
          text: ", and we have prepared the calculations on this basis.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Appointing a nominated reporting company for the group. You have informed us that ",
          font: defaultFontNormal,
        },
        {
          text: reportingCompanyName,
          font: defaultFontNormal,
        },
        {
          text: " was appointed as the reporting company for the group, and we have prepared the CIR return on this basis.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "The calculations have been prepared on the basis of the application of the fixed ratio only. Accordingly, we have not prepared calculations on the basis of the group ratio method of calculation, nor have we assessed whether or not the group ratio could give a beneficial result for the group.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "The calculations have been prepared on the basis that no elections have been made for CIR purposes, other than any elections which you have told us you have made. We have not separately considered the application of any elections which may be available.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "This report is prepared solely for the purpose of reporting on the Group’s CIR calculations for the period of account ended ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: `${formattedPoAEnd}.`,
          font: defaultFontNormal,
        },
        {
          text: " This report has been prepared only for you and solely for the purpose and on the terms agreed with you in our engagement letter dated ",
          color: blueColour,
          font: defaultFontNormal,
        },
        {
          text: "[date].",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
    {
      segments: [
        {
          text: "Our advice is based on the law, regulations and guidance applying at the date the services are provided. We will not monitor or be responsible for the effects of any subsequent changes in law, regulations, or guidance.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "We have not carried out anything in the nature of an audit, nor have we subjected any information or assumptions or conclusions or other statements contained in this report to checking or verification procedures. Accordingly, save anything expressly agreed by us in writing, we accept no liability (including for negligence) to anyone else or for any other purpose in connection with this paper and it may not be provided to anyone else.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Scope and Exclusions"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
